/**
 * @author MadhuSudhan
 * @Date: 2023-09-18 13:05:13
 * @Last Modified by: madhusudhan
 * @Last Modified time: 2023-09-17 13:14:33
 */

import { createSelector } from 'reselect';
import { utils } from '../../devUtils';

const selectYscCardActionsDomain = (state) => state.get('yscCardActions');
const selectYscCardActionsDetails = () => createSelector(
  selectYscCardActionsDomain,
  (YscCardActions) => YscCardActions,
);

const select_CardAction = (key) => createSelector(
  selectYscCardActionsDomain,
  (YscCardActions) => utils.immutableToJS(YscCardActions.get(key)),
);

export {
  selectYscCardActionsDetails,
  select_CardAction,
};



// WEBPACK FOOTER //
// client/containers/YscCardActions/selectors.js